export const UI_updateConvUIStepsStatusReducer = {
  UI_updateConvUIStepsStatus: (state, action) => {
    state.convUiStepsDetails = [...action.payload];
  },
};
